import React, { useState, useRef, useEffect } from 'react';

const ZoomableImage = ({ src, alt, style }) => {
  const [isZoomed, setIsZoomed] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const imgRef = useRef(null);

  const toggleZoom = (e) => {
    e.stopPropagation();
    if (isZoomed) {
      setIsZoomed(false);
      setPosition({ x: 0, y: 0 });
    } else {
      setIsZoomed(true);
    }
  };

  const handleStart = (e) => {
    if (!isZoomed) return;
    setIsDragging(true);
    const clientX = e.type.startsWith('touch') ? e.touches[0].clientX : e.clientX;
    const clientY = e.type.startsWith('touch') ? e.touches[0].clientY : e.clientY;
    setDragStart({ x: clientX - position.x, y: clientY - position.y });
  };

  const handleMove = (e) => {
    if (!isZoomed || !isDragging) return;
    e.preventDefault();
    const clientX = e.type.startsWith('touch') ? e.touches[0].clientX : e.clientX;
    const clientY = e.type.startsWith('touch') ? e.touches[0].clientY : e.clientY;
    
    // Limits calculation can be added here if needed
    setPosition({
      x: clientX - dragStart.x,
      y: clientY - dragStart.y
    });
  };

  const handleEnd = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    if (isZoomed) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isZoomed]);

  return (
    <div 
      className={`zoomable-image-container ${isZoomed ? 'zoomed' : ''}`}
      style={{
        overflow: 'hidden',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        touchAction: isZoomed ? 'none' : 'auto',
        cursor: isZoomed ? 'grab' : 'zoom-in',
      }}
      onMouseDown={handleStart}
      onMouseMove={handleMove}
      onMouseUp={handleEnd}
      onMouseLeave={handleEnd}
      onTouchStart={handleStart}
      onTouchMove={handleMove}
      onTouchEnd={handleEnd}
    >
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        onDoubleClick={toggleZoom}
        style={{
          ...style,
          transition: isDragging ? 'none' : 'transform 0.3s ease',
          transform: `translate(${position.x}px, ${position.y}px) scale(${isZoomed ? 2 : 1})`,
          userSelect: 'none',
          pointerEvents: 'auto',
        }}
      />
    </div>
  );
};

export default ZoomableImage;
